import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { CatalogItemComponent } from './catalog-item.component';
import { DaProgressiveImageModule } from '../da-progressive-image';

@NgModule({
    declarations: [CatalogItemComponent],
    exports: [CatalogItemComponent],
    imports: [CommonModule, RouterModule, DaProgressiveImageModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class CatalogItemModule {}
